import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/SimpleList/simple-list';
import { SimpleListGroup } from './SimpleListGroup';
export var SimpleListContext = React.createContext({});
export var SimpleList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SimpleList, _React$Component);

  function SimpleList() {
    var _this;

    _classCallCheck(this, SimpleList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleList).apply(this, arguments));
    _this.state = {
      currentRef: null
    };

    _this.handleCurrentUpdate = function (newCurrentRef, itemProps) {
      _this.setState({
        currentRef: newCurrentRef
      });

      var onSelect = _this.props.onSelect;
      onSelect && onSelect(newCurrentRef, itemProps);
    };

    return _this;
  }

  _createClass(SimpleList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!SimpleList.hasWarnBeta && process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('This component is in beta and subject to change.');
        SimpleList.hasWarnBeta = true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          onSelect = _a.onSelect,
          props = __rest(_a, ["children", "className", "onSelect"]);

      var isGrouped = false;

      if (children) {
        isGrouped = React.Children.toArray(children)[0].type === SimpleListGroup;
      }

      return React.createElement(SimpleListContext.Provider, {
        value: {
          currentRef: this.state.currentRef,
          updateCurrentRef: this.handleCurrentUpdate
        }
      }, React.createElement("div", Object.assign({
        className: css(styles.simpleList, className)
      }, props, isGrouped && {
        role: 'list'
      }), isGrouped && children, !isGrouped && React.createElement("ul", null, children)));
    }
  }]);

  return SimpleList;
}(React.Component);
SimpleList.hasWarnBeta = false;
SimpleList.defaultProps = {
  children: null,
  className: ''
};